// extracted by mini-css-extract-plugin
export var closeButton = "_j9-2";
export var closeButtonIcon = "_j9-3";
export var lightboxContent = "_j9-1";
export var lightboxOverlay = "_j9-0";